/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadSOffenderRecordRequest
 */
export interface UpdateLeadSOffenderRecordRequest {
    [key: string]: any | any;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLeadSOffenderRecordRequest
     */
    is_dismissed: boolean;
    /**
     * Deprecated - will be ignored, use lead_id from existing record
     * @type {string}
     * @memberof UpdateLeadSOffenderRecordRequest
     */
    lead_id?: string;
}

/**
 * Check if a given object implements the UpdateLeadSOffenderRecordRequest interface.
 */
export function instanceOfUpdateLeadSOffenderRecordRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_dismissed" in value;

    return isInstance;
}

export function UpdateLeadSOffenderRecordRequestFromJSON(json: any): UpdateLeadSOffenderRecordRequest {
    return UpdateLeadSOffenderRecordRequestFromJSONTyped(json, false);
}

export function UpdateLeadSOffenderRecordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadSOffenderRecordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'is_dismissed': json['is_dismissed'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
    };
}

export function UpdateLeadSOffenderRecordRequestToJSON(value?: UpdateLeadSOffenderRecordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'is_dismissed': value.is_dismissed,
        'lead_id': value.lead_id,
    };
}

